import { render } from "./ResetPasswordUser.vue?vue&type=template&id=46fd662e"
import script from "./ResetPasswordUser.vue?vue&type=script&lang=js"
export * from "./ResetPasswordUser.vue?vue&type=script&lang=js"

import "./ResetPasswordUser.vue?vue&type=style&index=0&id=46fd662e&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__